import { useContext, useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { generalGet } from '../../../API/api';
import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import { authContext } from '../../../store/context/authContext';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import PagesTableContainer from '../../../modules/pages/components/PagesTableContainer';

const Pages = () => {
  const { catchError } = useContext(authContext);
  const { t, i18n } = useTranslation();
  const [refetch, setRefetch] = useState(false);
  // const [pages, setPages] = useState<IFuelType[]>([]);

  const { currentRoute, setMetaData, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'pages',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.pages'),
    withPagination: true
  });
  const { data, isSuccess, isLoading, error } = useQuery({
    queryKey: ['pages', refetch, i18n, currentRoute],
    queryFn: () => generalGet(currentRoute),
    refetchOnWindowFocus: false,
    enabled: false
  });

  useEffect(() => {
    error && catchError(error);
  }, [error]);

  useEffect(() => {
    // const reqData = data?.data.data;
    if (isSuccess) {
      // setFuelTypes(reqData);
    }
    setMetaData(data?.data?.meta);
  }, [isSuccess, data]);

  const tableHeaders = [{ label: t('name') }, { label: t('actions'), customClass: 'actions_col' }];

  const pages = useMemo(
    () => [
      {
        id: 1,
        name: 'homepage'
      },
      {
        id: 2,
        name: 'services'
      },
      {
        id: 3,
        name: 'offers'
      }
    ],
    []
  );

  if (isLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="pages-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
      </ListHeader>
      <PagesTableContainer tableHeaders={tableHeaders} data={pages} noDataMessage={t('no_pages_found')} setRefetchData={setRefetch} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Pages;
